<script setup lang="ts">
import { TrashIcon } from "@heroicons/vue/outline";

type Props = {
  placeholder?: string;
  showRemove?: boolean;
};

type Emits = {
  (e: "remove"): void;
};

const model = defineModel<string>({ default: "" });
const { placeholder = "", showRemove = false } = defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="flex items-center gap-2">
    <input
      v-model="model"
      required
      type="text"
      class="w-full appearance-none rounded-sm border-2 border-kekkle-dark px-3 py-2 text-kekkle-dark shadow-purple-hard-sm outline-hidden focus:ring-3 focus:ring-kekkle-purple dark:bg-kekkle-dark-light dark:text-slate-200"
      :placeholder="placeholder"
    />
    <button
      v-if="showRemove"
      type="button"
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border-2 border-kekkle-dark bg-kekkle-red-light text-kekkle-dark shadow-red-hard-sm transition-all active:translate-y-0.5 active:shadow-none dark:bg-kekkle-dark-light dark:text-red-400"
      @click.prevent="emit('remove')"
    >
      <TrashIcon class="h-5 w-5" />
    </button>
  </div>
</template>
